import * as React from 'react'
export const SvgLogoutOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path d="M21 3v18H9v-6.003h2V19h8V5h-8v4H9V3h12zM7.002 9v2h8v2h-8v2.003L3 12.002 7.002 9z" />
  </svg>
)
export default SvgLogoutOutline
